<template>
  <div>
    <header>
      <Header />
    </header>
    <div id="main">
        <section class="report">

            <div class="reportTitle">
                <div class="inner4">
                    <h1>トークショーレポート</h1><p class="titleSub">Talk Show Reports</p>
                </div><!-- /inner4-->
            </div><!-- /reportTitle-->

            <section class="reportVhead reportVhead01">
                <div class="inner4">
                    <h1><img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/tcc/title.png" srcset="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/tcc/title@2x.png 2x" alt="なぜ人々は「北海道東川町」に惹き付けられるのか" /></h1>
                </div><!-- /inner4-->
            </section><!-- /reportVhead-->

            <div class="reportBody">

                <section class="txtBlock">
                    <div class="inner4">
                        <p>
                            2022年9月16日（金）～9月19日（月・祝）、東京・渋谷ヒカリエにて「東京カメラ部2022写真展」が開催されました。開催期間中のイベントステージでは、人気フォトグラファー、写真業界関係者、歴代東京カメラ部10選などをお招きして、さまざまなテーマでトークショーが行われました。
                        </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="txtBlock">
                    <div class="inner4">
                        <p>
                            <!-- eslint-disable no-irregular-whitespace -->
                            9月19日（月・祝）に行われた東京カメラ部のトークショーでは、東京カメラ部10選　井上裕康氏、東京カメラ部10選　小林 淳氏、東京カメラ部10選　shabon氏、東京カメラ部10選　恒松泰至氏にご登壇いただき、「【東京カメラ部2022写真展】カウントダウントークショー『写真との出会いは、世界との出会いだ。』」というテーマでお話しいただきました。<br>
                            ※shabon氏は顔出しNGのため、お面を付けた状態でご登壇いただいております。
                        </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/tcc/01.jpg" alt="東京カメラ部 01" />
                    </div><!-- /inner4-->
					<div class="exif">
						<p>
						</p>
					</div><!-- /exif-->
                </section><!-- /photoBlock-->

				
                <section class="txtBlock">
                    <div class="inner4">
                        <p>
                            東京カメラ部運営 塚崎（司会）「連休の最終日、わざわざこのステージまで足を運んでくださりありがとうございます。最後のトークショーは、カウントダウントークショーとなります。テーマは『写真との出会いは、世界との出会いだ。』この写真展のテーマそのものです。スペシャルゲスト4名の方の作品を拝見しながらお話を進めていきたいと思います」
                        </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/tcc/02.jpg" alt="東京カメラ部 02" />
                    </div><!-- /inner4-->
					<div class="exif">
						<p>
						</p>
					</div><!-- /exif-->
                </section><!-- /photoBlock-->
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            井上「東京カメラ部10選2021の井上裕康と申します。風景に着物の女性を入れて写真を撮っています。よろしくお願いいたします」<br>
                            <br>
                            塚崎「10選2021ということは、2022年度で一番新しい10選の方ですね。2022年なのに2021というと、年がずれていて分かりにくいかもしれませんが、それには理由があります。<br>
                            <br>
                            東京カメラ部10選は、毎年12月にその年の10選を選出させていただいている制度です。そしてその方々の写真を翌年に展示する形になっています。これは、初代10選に選出された方に、表彰に加えて、『われわれがお礼をするとしたらどのようなものがいいですか？』と伺ったところ、『写真展がいい』という要望をいただいた結果として、写真展が始まったからなんです。<br>
                            <br>
                            年のズレがあって分かりにくいかもしれませんが、ご理解をお願いいたします。では井上さんの作品を拝見してみましょう」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/tcc/03.jpg" alt="東京カメラ部 03" />
                    </div><!-- /inner4-->
					<div class="exif">
						<p>
						</p>
					</div><!-- /exif-->

                </section><!-- /photoBlock-->
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            井上「京都市の桃山御陵というところです」<br>
                            <br>
                            塚崎「モデルさんが身につけている着物が豪華ですね（笑」<br>
                            <br>
                            井上「いきなり、そこ来ましたか！そうですね、モデルさんの私物で大切なものなんです。（会場内のモデルさんと目を合わせつつ）三桁万円するとか…」<br>
                            <br>
                            塚崎「すみません。突っ込めと言われた気がして（笑。では、本筋の写真に戻りましょう」<br>
                            <br>
                            井上「ここは雪が滅多に降る場所ではないので、天気予報を聞いて、狙って撮りにいきました。天気は狙っていても外すときはありますが、この日はたまたま降っていました。雪が降りそうだなと思ったときに、いくつか場所の候補はあったのですが、初めて行くこの場所に決めました。みぞれまじりになっていたので、モデルさんも寒い中で頑張ってくれました。言い合いをしながらも、電話で通話しながらモデルさんに指示して撮影しましたね」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/tcc/04.jpg" alt="東京カメラ部 04" />
                    </div><!-- /inner4-->
					<div class="exif">
						<p>
						</p>
					</div><!-- /exif-->
                </section><!-- /photoBlock-->
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            井上「越前町の花火です。350mmのレンズで撮っています。花火大会の後半で撮れた一枚で、それまでは何も撮れていない状態でした。最後の方でようやく撮れた一枚です。河川敷で立っているモデルさんを下の方から望遠レンズで抜いています。70-200mmにテレコンをつけて、結果的に350mmです。このときは電波が悪くて電話が全然繋がらず、ほぼ何も指示できませんでしたが、モデルさんが機転を効かせてポーズを取ってくれました。普段から写真を撮る方なので汲み取ってくれたんだと思います」
                            <br>
                            塚崎「まさにチームプレーですね。モデルさんとは写真を通じて知り合ったんですか？」<br>
                            <br>
                            井上「そうですね。出会ったときは花火を撮っていたら横にいらっしゃって、話しているうちに仲良くなりました」<br>
                            <br>
                            塚崎「写真を通じてこうした出会いがあるということですね」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/tcc/05.jpg" alt="東京カメラ部 05" />
                    </div><!-- /inner4-->
					<div class="exif">
						<p>
						</p>
					</div><!-- /exif-->

                </section><!-- /photoBlock-->
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            井上「越前市のサマーフェスティバルで撮影しました。先ほどの写真と近い場所です。この場所は私有地だったのですが、ここで撮りたいなとぼーっと眺めていたら、持ち主が現れて、撮っていいよと言っていただけました」<br>
                            <br>
                            塚崎「それは嬉しいですね！ところで、小林さんも花火を撮影すると思いますが、いかがですか？」<br>
                            <br>
                            小林「モデルさんを入れて撮影する経験はあまりないですね。こういう場合はブレずにきれいに撮れるよう、モデルさんも長時間動いてはいけない状況だと思うので、感心します。」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/tcc/06.jpg" alt="東京カメラ部 06" />
                    </div><!-- /inner4-->
					<div class="exif">
						<p>
						</p>
					</div><!-- /exif-->

                </section><!-- /photoBlock-->
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            井上「元々はここを撮りに行くつもりはなくて、竹林でモデルさんに人力車に乗ってもらったところを撮影する予定でした。ところが時間ができたので行ってみたところ、誰もいなかったんです。普段は人気のスポットなので運がいいなと思いました」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/tcc/07.jpg" alt="東京カメラ部 07" />
                    </div><!-- /inner4-->
					<div class="exif">
						<p>
						</p>
					</div><!-- /exif-->
                </section><!-- /photoBlock-->
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            塚崎「それでは続いて小林さんお願いします」<br>
                            <br>
                            小林「東京カメラ部10選2019の小林淳と申します。リアルなトークショーは4年ぶりです。よろしくお願いいたします」<br>
                            <br>
                            塚崎「小林さんは2019年の10選なので、写真展をもうやらせていただいた気がしていたのですが初めてなんですよね？」<br>
                            <br>
                            小林「10選になって初めてのリアル展示が今回ですね。二枚展示していただけて嬉しいです」<br>
                            <br>
                            塚崎「2019年、2020年に10選になった方の初めての写真展はオンライン開催で、こういったリアルな写真展ができていなかったんですね。<br>
                            今年の10選の方の展示枚数を多くする関係で、2019年、2020年の10選の方はすこし枚数が少なくなってしまっていますが、ご容赦ください。それでは小林さんの写真を撮りはじめたきっかけを教えてください」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/tcc/08.jpg" alt="東京カメラ部 08" />
                    </div><!-- /inner4-->
					<div class="exif">
						<p>
						</p>
					</div><!-- /exif-->
                </section><!-- /photoBlock-->
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            小林「家族の記録を撮りたくてカメラを持ったというのがルーツです。次第に、記録だけではなくそこに芸術的要素、美しさを加えて家族の記録を残したいと思ったのがきっかけです」
                        </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/tcc/09.jpg" alt="東京カメラ部 09" />
                    </div><!-- /inner4-->
					<div class="exif">
						<p>
						</p>
					</div><!-- /exif-->
                </section><!-- /photoBlock-->
				
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            塚崎「そしていつの間にかこのような写真を撮りはじめるんですね」<br>
                            <br>
                            小林「家族だけだとなかなか付き合ってくれないこともありますから、地元の風景を撮って、地元のPRに使ってもらって、みんなに遊びにきてもらいたいなという思いで撮りました。今は、月と城は本当に人気の被写体で、メディアも来られますし、北海道からも撮りにいらっしゃるようになったのですが、こちらはわたしが8年前に初めて撮った月と城です」<br>
                            <br>
                            塚崎「今とだいぶ違いますね」<br>
                            <br>
                            小林「白飛びもしているし、ブレているし。月も小さいですよね」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/tcc/10.jpg" alt="東京カメラ部 10" />
                    </div><!-- /inner4-->
					<div class="exif">
						<p>
						</p>
					</div><!-- /exif-->
                </section><!-- /photoBlock-->

                <section class="txtBlock">
                    <div class="inner4">
                        <p>
                            塚崎「そしていまの写真がこちら」<br>
                            <br>
                            小林「いまだに『合成なんじゃないか』というお声があるくらいです。ですが合成ではありません。自分が城から遠くなったり近づいたり、アプリを使って月の軌道を調べたりすることで、わたしの月と城の写真も成長しました」<br>
                            <br>
                            塚崎「小林さんが撮影しはじめたころ、カメラ部にもたくさんのコメントやDMをいただきました。『このような合成写真をアップするとはどういう考えなのか説明してほしい』と。最近はTVでも放送されたりネットニュースでも取り上げられたりして、みなさんお分かりいただいているのですが、まだ先日『こんなふうに撮れるはずがない』とコメントをいただきました。するとみなさんが『これはこういうふうに撮るんだよ』とコメントで解説してくださりました。それでも『焦点距離などのデータが出ていないから、TVで取り上げるのはおかしい』と折れずにいらっしゃった方がつい最近にもいましたね。小林さんは罪作りですね。でも説明のための投稿もしていらっしゃるんですよね」
                        </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/tcc/11.jpg" alt="東京カメラ部 11" />
                    </div><!-- /inner4-->
					<div class="exif">
						<p>
						</p>
					</div><!-- /exif-->
                </section><!-- /photoBlock-->

                <section class="txtBlock">
                    <div class="inner4">
                        <p>
                            小林「なぜ合成のようなダイナミックな写真が撮れるのか、ということをTwitterの文字数制限以内で説明しました。自分が離れれば城の大きさは小さくなるし、月はそのまま、ということを説明をしました。納得いただけて、そこからメディアの取材も増えたと感じています」
                        </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/tcc/12.jpg" alt="東京カメラ部 12" />
                    </div><!-- /inner4-->
					<div class="exif">
						<p>
						</p>
					</div><!-- /exif-->
                </section><!-- /photoBlock-->
				
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            塚崎「そしてその結果、こういうことに繋がるんですね」<br>
                            <br>
                            小林「はい、岐阜市の観光ポスターに採用していただきました。デザイナーさんと組んでコンテストに何度かエントリーし、無事採用いただきまして、岐阜市の方にも好評だと言っていただけました」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/tcc/13.jpg" alt="東京カメラ部 13" />
                    </div><!-- /inner4-->
					<div class="exif">
						<p>
						</p>
					</div><!-- /exif-->
                </section><!-- /photoBlock-->
				
                <section class="txtBlock">
                    <div class="inner4">
                        <p>
                            小林「のちに10選に選んでいただいた一枚です。大気やチリの影響で本当にこういう色の月が出ている日がありました。上がってしまうと白くなってしまうのですが、地平線に月が近い段階は色がつきやすいんですね。お月様が出たばかりのときは黄色かったりオレンジ色だったりします。この日はまさかの赤色だったので、興奮してシャッターを切りましたね」<br>
                            <br>
                            塚崎「赤い月と言いうとまた合成か！となるかもしれませんが違います。青色は短波長なので散乱して遠くまで届きにくいのです。一方で赤色は長波長のため散乱しにくい。そのため光を散乱させる効果があるチリが増えると、赤色だけ目に届く。結果、赤く見えるんですね。地平線に近づくと太陽が赤く見えるのと同じ現象です。この写真のRAWデータもわたしたちは拝見しているので、合成ではないことは確認済みです」
                        </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/tcc/14.jpg" alt="東京カメラ部 14" />
                    </div><!-- /inner4-->
					<div class="exif">
						<p>
						</p>
					</div><!-- /exif-->
                </section><!-- /photoBlock-->
				
                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/tcc/15.jpg" alt="東京カメラ部 15" />
                    </div><!-- /inner4-->
					<div class="exif">
						<p>
						</p>
					</div><!-- /exif-->
                </section><!-- /photoBlock-->
				
                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/tcc/16.jpg" alt="東京カメラ部 16" />
                    </div><!-- /inner4-->
					<div class="exif">
						<p>
						</p>
					</div><!-- /exif-->
                </section><!-- /photoBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/tcc/17.jpg" alt="東京カメラ部 17" />
                    </div><!-- /inner4-->
					<div class="exif">
						<p>
						</p>
					</div><!-- /exif-->
                </section><!-- /photoBlock-->
				
                <section class="txtBlock">
                    <div class="inner4">
                        <p>
                            塚崎「そしてその取り組みの中でいろいろな展開もあるんですよね」<br>
                            <br>
                            小林「新しい世界との出会い、という意味で、こんなことがありました。Jリーグのユニフォームに月城を採用いただいています。選手までもが岐阜市の有名コンテンツを背負って戦っていただくということにも発展しました」<br>
                            <br>
                            塚崎「写真を通してこんな出会いがあったということですね」
                        </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/tcc/18.jpg" alt="東京カメラ部 18" />
                    </div><!-- /inner4-->
					<div class="exif">
						<p>
						</p>
					</div><!-- /exif-->
                </section><!-- /photoBlock-->
				
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            塚崎「そしてこちらの写真。少し風合いが変わりますね」<br>
                            <br>
                            小林「実はこの写真はスマートフォンで撮影しています。スマホに特殊な600mmくらいの望遠鏡をつけて、三脚を立てて撮っています。現在そういった取り組みを岐阜市と、10選の柄木さんとやっております。われわれはバズーカのようなレンズを使って月城を撮影して反響をいただいているのですが、それではカメラマンだけの被写体になってしまっていますよね。そうではなくて、ライト層やスマホユーザーの方にも、被写体としての月城に存分に興奮していただきたいということで、スマホでこちらを撮れるツアーとしての取り組みをモニタリングという形でやっています。こんなところまで月城という被写体が広がっています」<br>
                            <br>
                            塚崎「写真のインパクトが観光産業にダイレクトに関わっているということですね。そしてここからカメラの世界に入っていただくきっかけになるかもしれないですね」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/tcc/19.jpg" alt="東京カメラ部 19" />
                    </div><!-- /inner4-->
                </section><!-- /photoBlock-->
				
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            塚崎「続いてshabonさんお願いいたします」<br>
                            <br>
                            shabon「東京カメラ部10選2017のshabonです。主にポートレートを撮影しています。よろしくお願いします」<br>
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/tcc/20.jpg" alt="東京カメラ部 20" />
                    </div><!-- /inner4-->
					<div class="exif">
						<p>
						</p>
					</div><!-- /exif-->
                </section><!-- /photoBlock-->
				
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            shabon「長野県で撮影した写真です。わたしは撮影のときに本当に天気に恵まれなくて、曇りや雨の日が多いんです。そんな中でも、晴れていなくても楽しめるという一枚です。こういうお天気だからこそ撮れた一枚だと思います。晴れだから撮影に行くということではなく、どんなお天気でも楽しみたいと思いますね」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/tcc/21.jpg" alt="東京カメラ部 21" />
                    </div><!-- /inner4-->
                </section><!-- /photoBlock-->
				
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            shabon「花火大会の一枚です。この日は雨が降り過ぎまして、心が折れてしまったんですね。ずっと雨が降り続いていて、確かにリフレクションが撮れたのは良かったんですが、モデルさんの手先が痺れてしまって。先ほどは天気は関係ないと言いましたが、あまりにも悪すぎると辛いかなと思いましたね」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/tcc/22.jpg" alt="東京カメラ部 22" />
                    </div><!-- /inner4-->
                </section><!-- /photoBlock-->

                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            shabon「10選の友人と撮影旅行に行ったときの写真です。その友人は風景やシカを撮っていて、私はポートレートを撮っています。10選に選ばれなければ絶対に知り合わなかったジャンルの方で、そんな方と一緒に撮影旅行に行けたんですね。人との出会いは写真があったからこそだなと思います」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/tcc/23.jpg" alt="東京カメラ部 23" />
                    </div><!-- /inner4-->
                </section><!-- /photoBlock-->
				
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            shabon「私にとっては珍しい風景の写真です。その友人に教えてもらって、長秒で初めて滝を撮りました。すごく勉強になりましたね」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/tcc/24.jpg" alt="東京カメラ部 24" />
                    </div><!-- /inner4-->
                </section><!-- /photoBlock-->
				
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            塚崎「続いて恒松さんお願いいたします」<br>
                            <br>
                            恒松「東京カメラ部10選2020の恒松泰至です。九州で風景写真をメインに活動しています。2019年のヒカリエの写真展ではトークショーは見る側だったのですが、今回喋る側で参加させていただき、ありがとうございます。いつかこの舞台に立てたらいいなと思っていました」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/tcc/25.jpg" alt="東京カメラ部 25" />
                    </div><!-- /inner4-->
                </section><!-- /photoBlock-->
				
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            恒松「こちらは10選2020に選んでいただいた作品で、桜島が噴火している写真になります。星の軌跡と桜島の大地を洞窟からのぞいたような構図で撮影しており、地元の方にはよく「どこで撮ったの？」と尋ねられるのですが、実は有名な観光地なんです。お昼にはバスツアーのお客さんが来るような展望所で、そこにあった積み重なってる岩の隙間にカメラを差し込んで撮影しました。桜島の噴火を撮る場合は望遠で火口だけ切り取ったり、広角で撮影する場合も街の明かりと一緒に撮るのが一般的だったのですが、桜島の地に立ってみると荒々しい火山岩や独特な植物の風景が格好良く、風景を撮る人間としてもワクワクする被写体だったので、それらを写真で表現できるように超広角レンズを使用して撮影しました」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/tcc/26.jpg" alt="東京カメラ部 26" />
                    </div><!-- /inner4-->
                </section><!-- /photoBlock-->
				
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            恒松「次は2021年12月に種子島より打ち上げられたH-IIAロケット45号機の写真です。発射場から3km程の場所から撮影しており、12mmの超広角レンズを使用して撮影しています。写真では一枚に収まっていますが頭上を見上げるほど高く飛んでおり、設定で露出を限界まで落としても白飛びするくらい物凄く明るいです。地元の方の歓声を聞きながら体感する打ち上げは人生で最高の経験となりました。風景写真を続けていなければ種子島まで行きロケットを撮ろうと思い立つことは無かったと思います。写真を続けたことで世界が広がった瞬間です」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/tcc/27.jpg" alt="東京カメラ部 27" />
                    </div><!-- /inner4-->
                </section><!-- /photoBlock-->
				
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            恒松「こちらは鹿児島の霧島連山にある大浪池という場所です。標高が1200mのところにありまして、冬に寒波が来ると一面樹氷して真っ白になるんですね。その時の夜明けの瞬間を撮影したものになります。実はこの日わたしが現地についた時は展望が完全に真っ白で何も見えない状況だったんです。最初は星を撮ろうと思っていたのですが諦めそれから3時間経ち、もう帰ろうかと立ち上がったその時に、下の方から雲がスーッと引いていって、ステージの幕が上がる様に絶景が姿を現す瞬間を目の当たりにしたんです。この時はすごく感動して夢中でシャッターを切ったのを覚えています。風が強く氷点下の環境でしたが、適切な防寒と登山装備があればこのような景色に出会うこともできます」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/tcc/28.jpg" alt="東京カメラ部 28" />
                    </div><!-- /inner4-->
                </section><!-- /photoBlock-->
				
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            恒松「こちらも鹿児島県の景色で魚野フライトエリアというパラグライダーの発着場なのですが、雲海と日の出のスポットでもあります。ここは車で行くことができ、シーズンになると撮影に来られる方がたくさんいらっしゃるような場所です。今まで紹介した中でも比較的気軽に撮影ができる場所で、なぜこの写真を選んだかというと、実はこのとき家族で撮影に行きまして娘が初めて雲海を見れた時の写真なんです。わたしが写真を続けることで娘や家族の世界も広がるんじゃないかなと思った瞬間でもあります。テーマの『写真との出会いは世界との出会いだ。』に繋がるんじゃないかなと思い選ばせていただきました」<br>
                            <br>
                            小林「僕もカメラをやっていなかったら出会えなかった風景がたくさんあります。発信したり展示してもらうことで、その先に新しい世界がまた待っていると思います。写真の魅力というか、やっていてよかったなと思いますね」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/tcc/29.jpg" alt="東京カメラ部 29" />
                    </div><!-- /inner4-->
                </section><!-- /photoBlock-->
				
                <section class="txtBlock">
                    <div class="inner4">
                        <p>
                            塚崎「それでは最後に恒例となりますが、みなさまにお話をさせていただければと思います。<br>
                            <br>
                            まずはご来場のみなさま、天気の悪いなか、貴重な週末を使ってわざわざこのトークステージまでお越しくださり、ありがとうございます。いろいろな形で展示をしてくださっている展示者のみなさま、ありがとうございます。たくさんの方が写真展にお越しいただいています。この方たちは、東京カメラ部を見にきているわけではないんです。みなさまに会いたいと思い、みなさまの作品を見に来ているんです。本当に心から感謝をいたします。そして、こうしてご登壇いただいているみなさまにも、本当に感謝をしております。<br>
                            <br>
                            また、ヒカリエのような大会場で写真展を開催することは、わたしたちのだけの力では到底できません。多くの企業、団体や人のご支援でこの場は成り立っています。東京カメラ部はまだまだ小さい会社です。美しいプリントは、キヤノンさまや富士フイルムさまからご協賛をいただいております。会場を借りる、壁を建てる、そういったことも決してわれわれだけではできません。多くの企業や地方自治体のお力があってできていることです。心から感謝申し上げます。<br>
                            <br>
                            本日、みなさまにお伝えしたいことはお詫びです。<br>
                            <br>
                            『3年』です。3年、長かったなと感じます。2019年、こちらで写真展をやりました。初めてAホールに移ってきて、盛大な写真展をやって、こういった場でみなさまと写真展ができるようになり、毎年できるようになればと感じていました。少なくとも写真展は必ず開催しようと、みなさまとお約束をしました。ところが2年間、われわれは約束を果たすことができませんでした。本当に申し訳ありません。こちらの会場には、全国各地から若い方がご来場くださります。残念ながら、あの環境下で、若い方を東京に集め、また各地に返すという決断ができませんでした。どうかご理解をいただきたいです。<br>
                            <br>
                            ですが、今年やっと開催できました。そうは言っても、まだまだ悔しいこと、できなかったことがたくさんあります。今回はレセプションが大々的にできなかった。入選者の方をお迎えして表彰式を行っていたのですが、今年は行うことができませんでした。10選の直近の3世代の方と、ゲストは1名まで。乾杯も飲み会もなし。単純に賞を渡して、記念撮影をして終わり。実質30分でした。まったく密にならない、会話も生まれない。そういう意味では、感染症対策としてはかなり優秀ではありましたが、表彰式としては寂しいものでした。2019年であれば200名近くの方にお越しいただいて、展示者、入選者の方全員を表彰させていただいて、ご家族の方や企業の方にも来ていただけました。高円宮妃久子殿下にもお越しいただいておりました。それがこのような形になってしまったこと、本当に申し訳ありません。<br>
                            <br>
                            また、以前であればポートフォリオとしてプリントしたものを置いていただきました。展示作品以外にもどんな作品が撮られているかを見ていただいて、その方のことをより深く理解していただくことができていました。しかし今年は、複数の方が触って戻すものをOKにすることはどうしてもできませんでした。皆さんにとってとても大切なものということがわかっていながら、割愛させていただきました。本当に申し訳ありません。<br>
                            <br>
                            会場内には椅子がありません。立ち見の方もいらっしゃって、本当に申し訳ないです。この会場にはたくさんのお年寄りや小さいお子さんもいらっしゃっているなか、休憩を取ることもできない。われわれにとってもたまらないものでした」
                        </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/tcc/30.jpg" alt="東京カメラ部 30" />
                    </div><!-- /inner4-->
                </section><!-- /photoBlock-->
				
                <section class="txtBlock">
                    <div class="inner4">
                        <p>
                            塚崎「この写真展は、出展者の同窓会のようなものと言って集まってくださる。交流の場が大切だと理解しています。そうした際、控室があってそこで出展者同士が交流をして仲良くなるということをわれわれは知っていました。知っていながら、控室を無くしました。そこはやはり大量に会話が生まれ、密になり、どうしても目の届かない部分がある。検討した結果、そういう決断をしました。みなさまは本当に嫌だったと思います。でも、われわれに一人も文句を言ってこられないんです。本当に一人もですよ。申し訳ないけれど、本当にありがたい。<br>
                            <br>
                            そして打ち上げです。最終日の前の日に打ち上げをしてそこで交流をするのが恒例になっていますが、これもできなかった。今までの打ち上げでは出展者だけでなく友人を連れてきてよかったので、そこでいろいろな方が『今年は入選できなかったけど、来年は入選したい』と意気込みを語ってくれました。大事な場だったのに、それもできなかった。本当に申し訳ありません。わたしは今回しみじみ、当たり前だと思っていたことが全然当たり前じゃなかったということを痛感しました。写真展を開催して、交流して、人に見てもらうというこのささやかな願いは当たり前のことだと思っていました。でも違った。痛感しました。<br>
                            <br>
                            フランスの文学者ロマン・ロランにこういう言葉があります。『──世界をあるがままに見た上で、それを愛するには勇気がいる。』それまでわれわれは、写真を始めれば、世界はこんなに美しいということに気付けますよ、と言っていた。しかしロランの言う通り、世界を愛するのはこんなにキツイんだなということをしみじみと感じました。偉そうなことを言っていたんだなと。<br>
                            <br>
                            それでも、こういうことを考え直しました。ヘルマン・ヘッセの言葉です。『──世の中には実に美しいものが沢山あると思うと、自分は死ねなかった。だから君も、死ぬには美しすぎるものが人生には多々ある、ということを発見するようにしなさい。』これを改めて噛み締めて、自分自身もう一度出会いがあったという思いも込めて、今回の写真展のタイトルとしています。<br>
                            <br>
                            今年の写真展は、こういう思いを込めて、展示をさせていただきました。この思いがこの写真集（東京カメラ部2022写真展公式写真集『写真との出会いは、世界との出会いだ。』）の中にも入っているので、よろしければ見ていただきたいです。<br>
                            <br>
                            また、東京カメラ部はよく謎の組織と言われるのですが、実は会社なんです。どういった会社かということを紹介している本（ムック本『東京カメラ部　日本最大のＳＮＳ写真コミュニティー』）も日経ナショナル ジオグラフィックさんが出してくださっているので、こちらもぜひご覧ください」
                        </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/tcc/31.jpg" alt="東京カメラ部 31" />
                    </div><!-- /inner4-->
                </section><!-- /photoBlock-->
				
                <section class="txtBlock">
                    <div class="inner4">
                        <p>
                            塚崎「そして新しい展開、新しいお知らせがございます。われわれYouTubeチャンネルを開設しておりまして、そのなかで『名画から学ぶ　〜写真の見方、撮り方〜』というものがございます。実はすでに35回更新しております。大変多くの方に見ていただいていて、多いものだと10万回再生されています。動画の中では歴代の名画を解析して、写真に応用するとどうなるのかということを、みなさまに写真のご提供をいただいて、解説しています。実はこの度、この動画が本になることが決定いたしました。翔泳社さんからお声がけいただき、まだ発売はしていないのですが予約を受け付けております。<br>
                            <br>
                            そして2023年、来年です。写真展、どうするかというところなのですが、意思としてはもちろんやりたいと思っています。ただ、この時点で今年と同じようにヒカリエで、オフラインで必ず開催できるとは言えません。感染症次第ではありますが、多くの出展者のみなさま、企業のみなさまが、『来年もぜひお願いします』とおっしゃってくださいました。今回、わたしも会場を歩いていたのですが、お会いするみなさまの第一声が『開催してくれてありがとうございました』でした。本来はわれわれが言うべき言葉ですよね。その言葉はわたしの胸に届いています。なんとかしたいと思っていますので、応援をしていただけますと幸いです。<br>
                            <br>
                            そしてヒカリエでの写真展は本日終了になりますが、オンラインは継続して開催しています。オンラインのみでの展示の方もいらっしゃいますし、本当は会場に来たいけれど、お越しになれなかった方もいます。そういった方々と交流できる場がございます。オフラインとの交流とは異なりますが、コメントをしたりコメントバックをしたりということができるようになっています。展示されている方の作品もございます。ぜひこちらもご覧いただければと思います。<br>
                            <br>
                            今年は苦境の中でしたが、みなさまとこうして再会できたことを心から嬉しく思っています。また来年、お会いしましょう。ありがとうございました」
                        </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

            </div><!-- /reportBody-->

        </section><!-- /report-->

    </div><!-- /main-->

    <Footer />
    <div class="actionMenu">
        <UpButton />
    </div>
  </div>
</template>
<script>
import Header from '@/components/modules/Header.vue'
import Footer from '@/components/modules/Footer.vue'
import enumMixin from '@/concern/enumMixin'
import constMixin from '@/concern/constMixin'
import UpButton from '@/components/modules/UpButton.vue'

export default {
  mixins: [enumMixin, constMixin], // Enum値, const値の読み込み
  components: {
    Header,
    Footer,
    UpButton
  },
  data () {
    return {
    }
  },
  created () {
  },
  methods: {
    setTitleAndDescription (to) {
      document.title = (to.meta.title ? to.meta.title : '')
      document.querySelector("meta[name='description']").setAttribute('content', (to.meta.desc ? to.meta.desc : ''))
    }
  },
  computed: {
  },
  mounted () {
    // titleとdescriptionの設定
    this.setTitleAndDescription(this.$route)
  },
  watch: {
    $route: function (to) {
      this.setTitleAndDescription(to)
    }
  }
}
</script>

<style scoped>
.withRightLine {
  border-right: 1px solid #000;
}
.withLeftLine {
  border-left: 1px solid #000;
}
.report .reportVhead01{
    background-image: url("https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/tcc/titleBk.jpg");
    background-repeat: no-repeat;
    background-position: top center;
}
.natgeoLinkArea {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    max-width: 100%;
}
.natgeoLinkArea div {
    width: 43%;
    margin-bottom: 24px;
}
@media screen and (max-width:640px){
    .natgeoLinkArea {
        display: flex;
        flex-direction: column;
        justify-content: center;
    }
    .natgeoLinkArea div {
        width: unset;
        margin: 24px 16px;
    }
}
</style>
